module.exports = __webpack_public_path__ + "static/media/g-15.4c44c3a4.jpg";